<template>
  <HomePage />
</template>
<script>
import { mapActions } from 'pinia'
import { dashboardStore } from '@/stores/dashboard'
import HomePage from '@/components/HomePage.vue'
export default {
  name: 'HomeView',
  components: {
    HomePage
  },
  mounted() {
    this.setRefresh(true)
  },
  methods: {
    ...mapActions(dashboardStore, ['setRefresh'])
  }
}
</script>
<style lang="scss" scoped></style>
